import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import {
  BarChart3,
  TrendingUp,
  Clock,

  CheckCircle,
  XCircle
} from 'lucide-react';

const ModelComparisonStats = ({ stats }) => {
  const navigate = useNavigate();
  const statCards = [
    {
      title: 'Total Comparisons',
      value: stats.total_comparisons || 0,
      icon: BarChart3,
      color: 'blue',
      bgColor: 'bg-blue-500/10',
      textColor: 'text-blue-500'
    },
    {
      title: 'Completed',
      value: stats.completed_comparisons || 0,
      icon: CheckCircle,
      color: 'green',
      bgColor: 'bg-green-500/10',
      textColor: 'text-green-500'
    },
    {
      title: 'Running',
      value: stats.running_comparisons || 0,
      icon: Clock,
      color: 'yellow',
      bgColor: 'bg-yellow-500/10',
      textColor: 'text-yellow-500'
    },
    {
      title: 'Failed',
      value: stats.failed_comparisons || 0,
      icon: XCircle,
      color: 'red',
      bgColor: 'bg-red-500/10',
      textColor: 'text-red-500'
    },
    {
      title: 'Success Rate',
      value: `${stats.success_rate || 0}%`,
      icon: TrendingUp,
      color: 'purple',
      bgColor: 'bg-purple-500/10',
      textColor: 'text-purple-500'
    }
  ];

  const handleCardClick = (title) => {
    const map = {
      'Completed': 'completed',
      'Running': 'running',
      'Failed': 'failed',
      'Total Comparisons': 'all',
      'Success Rate': 'completed'
    };
    const status = map[title] || 'all';
    navigate(`/model-comparisons${status && status !== 'all' ? `?status=${encodeURIComponent(status)}` : ''}`);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
      {statCards.map((stat, index) => {
        const Icon = stat.icon;
        return (
          <Card
            key={index}
            role="button"
            tabIndex={0}
            onClick={() => handleCardClick(stat.title)}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleCardClick(stat.title); } }}
            className="cursor-pointer transition-colors hover:bg-accent/30 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent"
          >
            <CardContent className="p-6">
              <div className="flex items-center space-x-3">
                <div className={`p-2 ${stat.bgColor} rounded-lg`}>
                  <Icon className={`w-6 h-6 ${stat.textColor}`} />
                </div>
                <div>
                  <p className="text-sm text-gray-600">{stat.title}</p>
                  <p className="text-2xl font-bold">{stat.value}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default ModelComparisonStats;
